export default __webpack_public_path__ + "static/media/first_leading.b23dc2bd.webp";